import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TSummaryTranslation {
  id: number;
  organisationId: number;
  languageId: number;
  summaryTranslation: string;
  noteTranslation?: string;
  valid: boolean;
}

export interface ISummaryTranslation extends TSummaryTranslation {}

const SummaryTranslation = Model(
  (model: TSummaryTranslation): ISummaryTranslation => {
    const _value: TSummaryTranslation = Object.assign({}, model);

    let _model = {
      get id() {
        return _value.id;
      },
      set id(value) {
        _value.id = value;
      },
      get organisationId() {
        return _value.organisationId;
      },
      set organisationId(value) {
        _value.organisationId = value;
      },
      get languageId() {
        return _value.languageId;
      },
      set languageId(value) {
        _value.languageId = value;
      },
      get summaryTranslation() {
        return _value.summaryTranslation;
      },
      set summaryTranslation(value) {
        _value.summaryTranslation = value;
      },
      get noteTranslation() {
        return _value.noteTranslation;
      },
      set noteTranslation(value) {
        _value.noteTranslation = value;
      },
      get valid() {
        return _value.valid;
      },
      set valid(value) {
        _value.valid = value;
      }
    };

    return ValidatableObject<ISummaryTranslation>(_model);
  }
);

export default SummaryTranslation;
